import { Box } from "@mui/material";
import { listTbc } from "../../distflowAPI/salesmenApi";
import {
  formatAgGridFilters,
  formatAgGridSorting,
} from "../../distflowAPI/common";

import { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DatePickerCustom2 from "../../components/DatePicker2";
import dayjs from "dayjs";
import { DATE_FORMAT_FRONT } from "../../utils/constants";
import { getNoPages } from "../../utils";
import { downloadFile } from "../../distflowAPI/downloadFile";
import { filtersToApi } from "../../distflowAPI/common";

const cols = [
  {
    headerName: "SalesMan",
    field: "sales_man",
    flex: 1,
  },

  {
    headerName: "Item",
    field: "name",
    flex: 1,
  },
  {
    headerName: "SKU",
    field: "sku",
    flex: 1,
    maxWidth: 100,
  },
  {
    headerName: "Tag",
    field: "tag",
    flex: 1,
    maxWidth: 180,
  },
  {
    headerName: "U.Price",
    flex: 1,
    valueGetter: (params) => `$${params?.data?.unit_price}`,
    maxWidth: 120,
  },
  {
    headerName: "QTY",
    flex: 1,
    valueGetter: (params) => `${params?.data?.qty}`,
    maxWidth: 100,
  },
  {
    headerName: "Line Price",
    flex: 1,
    valueGetter: (params) =>
      `$${(params?.data?.qty * params?.data?.unit_price).toFixed(2)}`,
    maxWidth: 130,
  },
  {
    headerName: "Percentage",
    field: "percentage",
    flex: 1,
    valueGetter: (params) => `${params?.data?.percentage}%`,
    maxWidth: 120,
  },
  {
    headerName: "Amount",
    field: "commission",
    flex: 1,
    valueGetter: (params) => `$${params?.data?.commission}`,
    maxWidth: 120,
  },
  {
    headerName: "Invoice",
    field: "invoice",
    flex: 1,
    maxWidth: 120,
  },
  {
    headerName: "Date",
    field: "date",
    flex: 1,
    maxWidth: 120,
  },
  {
    headerName: "Paid?",
    field: "paid",
    flex: 1,
    maxWidth: 120,
    valueGetter: (params) => (params?.data?.paid ? "Yes" : "No"),
  },
];

export default function TBCreport() {
  const [salesMen, setSalesMen] = useState([]);
  const [orderBy, setOrderBy] = useState([]);
  const [filterBy, setFilterBy] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [dataLoading, setDataLoading] = useState(false);
  const [noPages, setNoPages] = useState(1);

  function refreshTable() {
    setDataLoading(true);
    const filterList = Object.keys(filterBy).map((fk) => {
      return { column: fk, value: filterBy[fk] };
    });
    listTbc(page, pageSize, filterList, orderBy).then((res) => {
      setSalesMen(res.data.results);
      setNoPages(parseInt(res.count / pageSize));
      setDataLoading(false);
    });
  }

  useEffect(() => {
    refreshTable();
    console.log(filterBy);
  }, [filterBy, orderBy, page, pageSize]);
  return (
    <Box>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", mb: "20px" }}
      >
        <Typography
          fontSize="23px"
          fontWeight={800}
          component="h2"
          data-testid="page-title"
        >
          TBC report
        </Typography>
        <Stack direction={"row"} spacing={1}>
          <Filters filterBy={filterBy} setFilterBy={setFilterBy} />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              let filterByS = "";
              Object.keys(filterBy).map((key) => {
                filterByS += `${key}=${filterBy[key]}&`;
              });
              downloadFile(
                `/api/accounting/tbc_report_download/?${filterByS}`,
                `commissions_export.csv`
              );
            }}
          >
            Export
          </Button>
        </Stack>
      </Box>
      <Box>
        <DataTable
          columnDefs={cols}
          rowData={salesMen}
          rowHeight={53}
          headerHeight={60}
          loading={dataLoading}
          onSortChanged={(event) =>
            setOrderBy(
              formatAgGridSorting(event.columnApi.columnModel.gridColumns)
            )
          }
          onFilterChanged={(event) =>
            setFilterBy(formatAgGridFilters(event.api.getFilterModel()) || [])
          }
          page={page}
          pageSize={pageSize}
          setPageSize={(pageSize) => setPageSize(pageSize)}
          noPages={noPages}
          setPage={(page) => setPage(page)}
        />
      </Box>
    </Box>
  );
}

function Filters({ filterBy, setFilterBy }) {
  const [minDate, setMinDate] = useState(dayjs().subtract(7, "days"));
  const [maxDate, setMaxDate] = useState(dayjs());
  function setFilterStatus(value) {
    const newFilter = { ...filterBy };
    newFilter["paid"] = value;
    setFilterBy(newFilter);
  }

  function setMinDateFilter(value) {
    const newFilter = { ...filterBy };
    newFilter["created_date__gte"] = minDate.format("YYYY-MM-DD");
    setFilterBy(newFilter);
  }
  function setMaxDateFilter(value) {
    const newFilter = { ...filterBy };
    newFilter["created_date__lte"] = maxDate.format("YYYY-MM-DD");
    setFilterBy(newFilter);
  }

  function setFilterSalesMan(value) {
    const newFilter = { ...filterBy };
    newFilter["search"] = value;
    setFilterBy(newFilter);
  }
  function setFilterTag(value) {
    const newFilter = { ...filterBy };
    newFilter["tag"] = value;
    setFilterBy(newFilter);
  }
  function setFilterSKU(value) {
    const newFilter = { ...filterBy };
    newFilter["tag"] = value;
    setFilterBy(newFilter);
  }
  useEffect(() => {
    setMinDateFilter(minDate);
  }, [minDate]);
  useEffect(() => {
    setMaxDateFilter(maxDate);
  }, [maxDate]);
  return (
    <Stack direction={"row"} spacing={2}>
      <TextField
        label={"SalesMan search"}
        value={filterBy.search}
        onChange={(e) => setFilterSalesMan(e.target.value)}
      />
      <TextField
        label={"Tag search"}
        value={filterBy.tag}
        onChange={(e) => setFilterTag(e.target.value)}
      />
      <TextField
        label={"SKU search"}
        value={filterBy.sku}
        onChange={(e) => setFilterSKU(e.target.value)}
      />
      <RadioGroup
        value={filterBy["paid"]}
        onChange={(e) => setFilterStatus(e.target.value)}
        row
      >
        <FormControlLabel control={<Radio />} label={"All"} value={""} />
        <FormControlLabel control={<Radio />} label={"Paid"} value={true} />
        <FormControlLabel control={<Radio />} label={"UnPaid"} value={false} />
      </RadioGroup>
      <DatePickerCustom2
        label={"min date"}
        controlledValue={minDate}
        setControlledValue={setMinDate}
        maxWidth={180}
      />
      <DatePickerCustom2
        label={"max date"}
        controlledValue={maxDate}
        setControlledValue={setMaxDate}
        maxWidth={180}
      />
    </Stack>
  );
}
